const $ = require("jquery");

function debounce(func, wait = 10, immediate = true) {
  let timeout;
  return function() {
    let context = this,
      args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

$(document).ready(function() {
  if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent) === true) {
    return;
  }

  let scrollPos = -1;

  const nav = document.querySelector(".header");
  const floatingBar = document.querySelector(".floating-bar");
  const button = document.querySelector(".vacancy-header__button");

  function checkHeaderPosition() {
    let windowY = window.scrollY;

    if (nav === null) {
      return;
    }

    // Scrolling UP
    if (windowY < scrollPos) {
      nav.classList.add("is-visible");
      nav.classList.remove("is-hidden");

      if (floatingBar !== null) {
        floatingBar.classList.add("is-header-visible");
        floatingBar.classList.remove("is-header-hidden");

        if (button.offsetTop - windowY < 0) {
          floatingBar.classList.add("is-visible");
          floatingBar.classList.remove("is-hidden");
        } else {
          floatingBar.classList.add("is-hidden");
          floatingBar.classList.remove("is-visible");
        }
      }
    } else {
      nav.classList.add("is-hidden");
      nav.classList.remove("is-visible");

      if (floatingBar !== null) {
        floatingBar.classList.add("is-header-hidden");
        floatingBar.classList.remove("is-header-visible");

        if (button.offsetTop - windowY < 0) {
          floatingBar.classList.add("is-visible");
          floatingBar.classList.remove("is-hidden");
        } else {
          floatingBar.classList.add("is-hidden");
          floatingBar.classList.remove("is-visible");
        }
      }
    }

    scrollPos = Math.abs(windowY);
  }

  window.addEventListener("scroll", debounce(checkHeaderPosition));
});
